export const isNewCompany = localStorage.getItem('type') === 'new_company';